export enum AppNames {
  ACCOUNT = 'account',
  SUPPORT = 'support',
  SETTINGS = 'settings',
  FLEET = 'fleet',
  AUTH = 'auth',
  LEGACY = 'legacy',
  ADVISOR = 'advisor',
  ORGANIZATIONS = 'organizations',
}
